// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { connectAuthEmulator, getAuth } from 'firebase/auth'
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { getRemoteConfig } from 'firebase/remote-config'
import { connectStorageEmulator, getStorage } from 'firebase/storage'
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: import.meta.env.VITE_APP_API_KEY,
    authDomain: import.meta.env.VITE_APP_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_APP_PROJECT_ID,
    storageBucket: import.meta.env.VITE_APP_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_APP_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_APP_APP_ID,
    measurementId: import.meta.env.VITE_APP_MEASUREMENT_ID,
}

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig)

// Initialize Services
export const auth = getAuth(firebaseApp)
export const firestore = getFirestore(firebaseApp)
export const functions = getFunctions(firebaseApp)
export const storage = getStorage(firebaseApp)
export const remoteConfig = getRemoteConfig(firebaseApp)

// Remote Config Defaults & Settings
remoteConfig.settings.minimumFetchIntervalMillis = import.meta.env.DEV ? 10000 : 3600000 // 10s in dev, 1h in prod
remoteConfig.defaultConfig = {
    ENABLE_V2S: false,
    ENABLE_STORYBOARD_AI_IMAGE_GENERATION: true,
    ENABLE_CHARACTER_AI_IMAGE_GENERATION: false,
    v2sInterestForm: '',
    v2sDemoLink: '',
    PRICING_PLANS: JSON.stringify({
        currencySymbol: '₹',
        plans: [
            {
                id: 'starter',
                name: 'Starter',
                tier: 'free',
                description: 'For casual writers exploring ideas.',
                monthlyPrice: 0,
                yearlyPrice: 0,
                originalYearlyPrice: 0,
                razorpayMonthlyPlanId: '',
                razorpayYearlyPlanId: '',
                features: ['Basic screenplay formatting', 'Standard character libraries', 'Limited AI generation', 'Workspace access'],
                highlighted: false,
                buttonText: 'Current Plan',
                credits: 100
            },
            {
                id: 'film_maker',
                name: 'Film Maker',
                tier: 'paid',
                description: 'Premium tools for serious creators.',
                monthlyPrice: 50,
                yearlyPrice: 500,
                originalYearlyPrice: 600,
                razorpayMonthlyPlanId: 'plan_SU0CAqY5gC6c29',
                razorpayYearlyPlanId: 'plan_SU0CfYZARXP2ff',
                features: ['Premium AI image generation', 'Advanced screenplay co-writer', 'Unlimited character generations'],
                highlighted: true,
                buttonText: 'Choose Film Maker',
                credits: 1000
            },
            {
                id: 'director',
                name: 'Director',
                tier: 'paid',
                description: 'All features unchained to bring stories to life.',
                monthlyPrice: 100,
                yearlyPrice: 1000,
                originalYearlyPrice: 1200,
                razorpayMonthlyPlanId: '',
                razorpayYearlyPlanId: '',
                features: ['Everything in Film Maker', 'Priority access to new AI models', 'Priority support'],
                highlighted: false,
                buttonText: 'Choose Director',
                credits: 5000
            }
        ]
    })
}

// Connect to Emulators in development
if (import.meta.env.DEV) {
    console.log('🔧 Connecting to Firebase Emulators...')

    // Auth Emulator (default port: 9099)
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true })
    console.log('  ✓ Auth Emulator: localhost:9099')

    // Firestore Emulator (default port: 8080)
    connectFirestoreEmulator(firestore, 'localhost', 8080)
    console.log('  ✓ Firestore Emulator: localhost:8080')

    // Functions Emulator (default port: 5001)
    connectFunctionsEmulator(functions, 'localhost', 5001)
    console.log('  ✓ Functions Emulator: localhost:5001')

    // Storage Emulator (default port: 9199)
    connectStorageEmulator(storage, 'localhost', 9199)
    console.log('  ✓ Storage Emulator: localhost:9199')
}
